export default __webpack_public_path__ + "static/contact-flowers-2c468b800c7d7aa72c1825300d130466.svg";